var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { attrs: { model: _vm.form, "label-width": "120px" } },
    [
      _c(
        "el-form-item",
        { attrs: { label: "商品信息：" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "10px",
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                width: "70%",
              },
            },
            [
              _c("span", [
                _vm._v("已选择 " + _vm._s(_vm.goodsList.length) + " 个商品"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.openAddGoodsDialog },
                },
                [_vm._v("\n        添加商品\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "70%" },
              attrs: {
                data: _vm.goodsList,
                border: "",
                fit: "",
                "highlight-current-row": "",
                size: "mini",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "goodsFnId",
                  label: "商品ID",
                  width: "150",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsName",
                  label: "商品名称",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "price",
                  label: "市场价",
                  width: "150",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.marketPrice) +
                            "  (元)\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "促销价格", width: "150", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            placeholder: "请输入促销价格",
                            precision: 2,
                            min: 0,
                            size: "mini",
                          },
                          model: {
                            value: scope.row.activityPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "activityPrice", $$v)
                            },
                            expression: "scope.row.activityPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.removeGoods(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            删除\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加商品",
            visible: _vm.addGoodsDialogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addGoodsDialogVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            staticStyle: { "margin-bottom": "15px" },
            attrs: { placeholder: "请输入商品名称搜索", clearable: "" },
            on: { input: _vm.searchGoods },
            model: {
              value: _vm.goodsSearchKeyword,
              callback: function ($$v) {
                _vm.goodsSearchKeyword = $$v
              },
              expression: "goodsSearchKeyword",
            },
          }),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-bottom": "0" },
              attrs: {
                data: _vm.searchGoodsList,
                border: "",
                size: "mini",
                height: "400",
              },
              on: { "selection-change": _vm.handleGoodsSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "50", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsFnId",
                  label: "商品ID",
                  width: "120",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsName",
                  label: "商品名称",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "marketPrice",
                  label: "市场价",
                  width: "100",
                  align: "center",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addGoodsDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmAddGoods },
                },
                [_vm._v("确定添加")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "促销开关：" } },
        [
          _c("el-switch", {
            model: {
              value: _vm.form.markForEnable,
              callback: function ($$v) {
                _vm.$set(_vm.form, "markForEnable", $$v)
              },
              expression: "form.markForEnable",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.markForEnable
        ? [
            _c(
              "el-form-item",
              { attrs: { label: "点餐类型：", prop: "menuType" } },
              [
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.form.menuTypes,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "menuTypes", $$v)
                      },
                      expression: "form.menuTypes",
                    },
                  },
                  _vm._l(_vm.menuTypeList, function (item) {
                    return _c(
                      "el-checkbox",
                      { key: item.code, attrs: { label: item.code } },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.desc) + "\n        "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "会员专享：", prop: "vipMember" } },
              [
                _c("el-checkbox", {
                  attrs: { label: "是" },
                  model: {
                    value: _vm.form.vipMember,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "vipMember", $$v)
                    },
                    expression: "form.vipMember",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "执行日期：" } },
              [
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.form.executeDateList,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "executeDateList", $$v)
                      },
                      expression: "form.executeDateList",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "datetimerange",
                            format: "yyyy-MM-dd HH:mm:ss",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          model: {
                            value: _vm.form.executeDateList,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "executeDateList", $$v)
                            },
                            expression: "form.executeDateList",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "每日生效时间：", required: "" } },
              [
                _c("el-time-picker", {
                  attrs: {
                    "is-range": "",
                    format: "HH:mm:ss",
                    "value-format": "HH:mm:ss",
                    "range-separator": "至",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间",
                  },
                  model: {
                    value: _vm.form.dailyTimeRange,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "dailyTimeRange", $$v)
                    },
                    expression: "form.dailyTimeRange",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "执行星期：" } },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticStyle: { display: "inline-block" },
                    model: {
                      value: _vm.form.daysOfWeekList,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "daysOfWeekList", $$v)
                      },
                      expression: "form.daysOfWeekList",
                    },
                  },
                  _vm._l(7, function (item) {
                    return _c(
                      "el-checkbox",
                      { key: item, attrs: { label: item } },
                      [_vm._v("\n          " + _vm._s(item) + "\n        ")]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-left": "10px",
                      color: "#909399",
                      "font-size": "12px",
                    },
                  },
                  [_vm._v("（不选默认整周生效）")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "全部门店：", prop: "storeScope" } },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { "true-label": 0, "false-label": 1 },
                    model: {
                      value: _vm.form.storeScope,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "storeScope", $$v)
                      },
                      expression: "form.storeScope",
                    },
                  },
                  [_vm._v("\n        全部门店\n      ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.form.storeScope === 1
              ? _c(
                  "el-form-item",
                  { attrs: { label: "指定门店", prop: "relatedStoreIdList" } },
                  _vm._l(_vm.regionStoreList, function (regionStore) {
                    return _c("region-store-pane", {
                      key: regionStore.regionId,
                      attrs: {
                        "region-store": regionStore,
                        "echo-store-ids": _vm.form.relatedStoreIdList,
                      },
                      on: { change: _vm.handleRegionStoreChange },
                    })
                  }),
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
            [_vm._v("\n      提交\n    ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }